import { useContext } from 'react';
import {
  Box,
  alpha,
  Stack,
  lighten,
  IconButton,
  Tooltip,
  styled,
  useTheme
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import CloseTwoToneIcon from '@mui/icons-material/CloseTwoTone';
import HeaderButtons from './Buttons';
import HeaderUserbox from './Userbox';
import Cart from './Buttons/Cart';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { selectPetLicenseCartItems } from 'src/redux-store/slices/cartSlice';
import { canUsePetLicenseBundleCheckout } from 'src/utils/petLicenseBundleEligibility';
import Logo from 'src/components/LogoSign';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.spacing(8)}; // Adjusted for header height
        color: ${theme.palette.text.primary}; // Use theme text color
        right: 0;
        z-index: 6;
        background-color: ${alpha(
    theme.palette.background.paper,
    0.95
  )}; // Adjust for background opacity
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        // @media (min-width: ${theme.breakpoints.values.lg}px) {
        //     left: ${theme.spacing(30)}; // Adjust for sidebar width
        //     width: auto;
        // }
`
);
function Header({ IsDashboard }) {
  const { sidebarToggle, toggleSidebar } = useContext(SidebarContext);
  const theme = useTheme();
  const userDetails = useSelector((store: RootState) => store.user.userDetails);
  const currentPermitDetails = useSelector(
    (store: RootState) => store.currentPermit.currentPermitDetails
  );
  const petLicenseCartItems = useSelector(selectPetLicenseCartItems);
  const isSubscribed = userDetails?.TownshipPermits?.length !== 0;
  const isAdmin = userDetails?.UserRole === 'Admin';
  const isSuperAdmin = userDetails?.UserRole === 'Super Admin';
  const showCart =
    !isSuperAdmin &&
    (!isSubscribed ||
      isAdmin ||
      (canUsePetLicenseBundleCheckout(
        currentPermitDetails?.currentPermitUserRole,
        userDetails?.UserRole
      ) &&
        petLicenseCartItems.length > 0));

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === 'dark'
            ? `0 1px 0 ${alpha(
              lighten(theme.palette.primary.main, 0.7),
              0.15
            )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
              theme.palette.common.black,
              0.2
            )}, 0px 5px 22px -4px ${alpha(theme.palette.common.black, 0.1)}`,
        [theme.breakpoints.up('lg')]: {
          ml: (IsDashboard !== 1) && theme.spacing(30) // Adjusting for sidebar width
        }
      }}
      p={{ sm: '0px 18px' }}
    >
      <Box display="flex" alignItems="center">
        <Stack direction="row" alignItems="center">
          <Box mt={1}>
            <Box
              mx={2}
              sx={{
                height: '57px',
                display: { lg: 'inline-block', xs: 'none' }
              }}
            >
              <Logo />
            </Box>
          </Box>
          <Box
            component="span"
            sx={{
              display: { lg: 'none', xs: 'inline-block' }
            }}
          >
            <Tooltip arrow title="Toggle Menu">
              <IconButton color="primary" onClick={toggleSidebar}>
                {!sidebarToggle ? (
                  <MenuTwoToneIcon fontSize="large" />
                ) : (
                  <CloseTwoToneIcon fontSize="large" />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </Stack>
      </Box>
      <Box display="flex" alignItems="center">
        {showCart && <Cart />}
        {isSubscribed && <HeaderButtons />}
        <HeaderUserbox />
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
